import { CounterConfig, CounterState, formatNumber } from '@gripp/shared-logic';
import { FC } from 'react';
import { SubHeaderText } from '../../asset/subHeaderText';
import { RoutineHeaderProps } from '../types';
import { CounterComponentProps } from './types';

interface CounterHeaderProps
  extends CounterComponentProps,
    RoutineHeaderProps<CounterConfig, CounterState> {}

export const CounterHeader: FC<CounterHeaderProps> = (
  props: CounterHeaderProps
) => {
  const { config, currentState } = props;

  const count = formatNumber(
    currentState?.state?.count ?? 0,
    config.decimalPlaces ?? 0,
    true
  );

  return <SubHeaderText>{`${count} ${config.uom}`}</SubHeaderText>;
};
